// import Cookies from 'js-cookie';

import { sendCustomCartData } from './shared/service/myintegrator/api/global';
import { CompanyState } from './store/slices/company';
import {
  // bindLinks,
  initApp,
  // requestIdleCallbackFunction,
  // unbindLinks
} from './load-functions';
import { AddressItemType } from './types';

// // check if the accesed url contains a hashtag or checkout (to speed up process on loading css) - Steven
// if (window.location.hash.startsWith('#/') || window.location.href.includes('/checkout')) {
//   initApp();
// } else {
//   // load the app when the browser is free
//   requestIdleCallbackFunction(initApp);
//   // and bind links to load the app
//   bindLinks();
//   window.addEventListener('beforeunload', unbindLinks);
//   // and observe global flag to simulate click
//   window.b2b.initializationEnvironment.isInitListener = () => {
//     unbindLinks();
//     setTimeout(() => window.b2b.initializationEnvironment.clickedLinkElement?.click(), 0);
//   };
// }

initApp();

// function attachOrderCommentListener() {
//   const input = document.getElementById('myship-customer-comment-field') as HTMLInputElement | null;

//   if (!input) return;

//   input.addEventListener('focus', () => {
//     const continueBtn = document.getElementById(
//       'checkout-payment-continue',
//     ) as HTMLButtonElement | null;
//     if (continueBtn) {
//       continueBtn.disabled = true;
//     }
//   });

//   input.addEventListener('blur', async () => {
//     const cartId = Cookies.get('cartId');
//     if (!cartId) return;

//     const newMessage = input.value;

//     try {
//       const response = await fetch(`/api/storefront/checkouts/${cartId}`, {
//         method: 'PUT',
//         credentials: 'include',
//         headers: {
//           'Content-Type': 'application/json',
//           Accept: 'application/json',
//         },
//         body: JSON.stringify({ customerMessage: newMessage }),
//       });

//       if (!response.ok) {
//         console.error('Failed to update customerMessage');
//       }

//       window.location.reload();
//     } catch (error) {
//       console.error('Error updating customerMessage:', error);
//     }
//   });
// }

// function injectOrderCommentFieldset() {
//   // Avoid duplicate insertion
//   if (document.getElementById('myship-customer-comment-field')) return;

//   const formActions = document.querySelector('li.checkout-step--payment .form-actions');
//   if (!formActions) return;

//   const fieldset = document.createElement('fieldset');
//   fieldset.className = 'form-fieldset';

//   fieldset.innerHTML = `
//     <legend class="form-legend optimizedCheckout-headingSecondary">
//       Order Comments
//     </legend>
//     <div class="form-body">
//       <div class="form-field">
//         <label for="orderComment"
//           class="form-label is-srOnly optimizedCheckout-form-label">
//           Order Comments
//         </label>
//         <input autocomplete="off" id="orderComment" maxlength="2000" type="text"
//           class="form-input optimizedCheckout-form-input"
//           name="orderComment" value="" data-note-added="true"
//           style="visibility: hidden; height: 0; padding: 0;">
//         <div>
//           Add any special instructions for the warehouse team.
//         </div>
//         <input autocomplete="off"
//           id="myship-customer-comment-field"
//           maxlength="2000" type="text"
//           class="form-input optimizedCheckout-form-input"
//           name="myship-customer-comment" value=""
//           data-note-added="true">
//       </div>
//     </div>
//   `;

//   // Insert just before the form actions container
//   formActions.parentElement?.insertBefore(fieldset, formActions);

//   // Attach update listener in case called directly
//   attachOrderCommentListener();
// }

// let hasFetchedCustomerMessage = false;
// async function fetchAndInjectCustomerMessage(): Promise<void> {
//   if (hasFetchedCustomerMessage) return; // Prevent multiple calls
//   hasFetchedCustomerMessage = true;

//   const cartId = Cookies.get('cartId');
//   if (!cartId) return;

//   try {
//     const response = await fetch(`/api/storefront/checkouts/${cartId}`, {
//       method: 'GET',
//       credentials: 'include',
//       headers: {
//         Accept: 'application/json',
//       },
//     });

//     if (!response.ok) {
//       console.error('Failed to fetch checkout data');
//       return;
//     }

//     const data = await response.json();
//     const message = data?.customerMessage || '';

//     injectOrderCommentFieldset();

//     const input = document.getElementById(
//       'myship-customer-comment-field',
//     ) as HTMLInputElement | null;
//     if (input && message) {
//       input.value = message;
//     }

//     attachOrderCommentListener();
//   } catch (err) {
//     console.error('Error fetching customer message:', err);
//   }
// }

function addCommaAfterThankYou() {
  const observer = new MutationObserver(() => {
    const h1 = document.querySelector('h1[data-test="order-confirmation-heading"]');
    if (!h1) return;

    if (!h1.textContent) return;

    const txt = h1.textContent.trim();
    if (txt.startsWith('Thank you') && !txt.startsWith('Thank you,')) {
      h1.textContent = txt.replace(/^Thank you\b/, 'Thank you,');
    }

    observer.disconnect(); // remove if you only want it once
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function observeAndHideShippingComments() {
  // Function to hide the fieldset inside the shipping step
  function hideFieldset() {
    const shippingStepSelector = 'li.checkout-step--shipping';
    const fieldsetSelector = 'fieldset.form-fieldset[data-test="checkout-shipping-comments"]';

    const shippingStep = document.querySelector(shippingStepSelector);
    if (!shippingStep) return;
    const fieldset = shippingStep.querySelector(fieldsetSelector) as HTMLElement;
    if (fieldset && fieldset.style.display !== 'none') {
      fieldset.style.display = 'none';
    }
  }

  // Initial hide on load if already present
  hideFieldset();

  // Observe changes inside the shipping step only
  const observer = new MutationObserver(() => {
    hideFieldset();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

const CART_LINK_ID = 'cart-edit-link';
const TARGET_HREF = '/consumables';

function updateCartLinkIfPresent(): boolean {
  const link = document.getElementById(CART_LINK_ID) as HTMLAnchorElement | null;
  if (!link) return false;

  // Only rewrite if it's the cart.php link
  const current = link.getAttribute('href') ?? '';
  if (current.includes('cart.php')) {
    link.setAttribute('href', TARGET_HREF);
  }
  return true;
}

function initCartLinkOverride() {
  // Try immediately in case it's already there
  if (updateCartLinkIfPresent()) return;

  // Otherwise watch for it
  const observer = new MutationObserver(() => {
    const updated = updateCartLinkIfPresent();
    if (updated) {
      observer.disconnect();
    }
  });

  // Observe the whole document; tweak if you know the exact container
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

// function observeAndRemoveCartEditLink() {
//   const selector = '#cart-edit-link';

//   function removeLink() {
//     const link = document.querySelector(selector);
//     if (link && link.parentNode) {
//       link.remove();
//     }
//   }

//   // Ensure body exists before observing
//   function initObserver() {
//     const body = document.body;
//     if (!body) {
//       // Retry once DOM is ready
//       window.addEventListener('DOMContentLoaded', initObserver, { once: true });
//       return;
//     }

//     // Initial removal
//     removeLink();

//     // Observe DOM for reinsertions
//     const observer = new MutationObserver(() => removeLink());
//     observer.observe(body, { childList: true, subtree: true });
//   }

//   initObserver();
// }

function hidePaymentInstruction() {
  function hideOrderConfirmationsWithPaymentInstructions() {
    document.querySelectorAll('.orderConfirmation-section').forEach((section) => {
      const el = section as HTMLElement;
      if (el.querySelector('[data-test="payment-instructions"]')) {
        el.style.display = 'none';
      }
    });
  }

  // Initial run
  hideOrderConfirmationsWithPaymentInstructions();

  // Observe for dynamically added sections
  const observer = new MutationObserver(() => {
    hideOrderConfirmationsWithPaymentInstructions();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function observerQueenslandSignature() {
  const b2bCompanyData = sessionStorage.getItem('b2b-kobe-company-data');
  const kobeCartType = sessionStorage.getItem('kobe-cart-type');
  if (!b2bCompanyData || !kobeCartType) return;

  const b2bCompany: CompanyState = JSON.parse(b2bCompanyData);
  const businessType = b2bCompany.companyInfo.extraFields.find(
    (extraField) => extraField.fieldName.toLowerCase() === 'pathology',
  );
  if (!businessType || businessType.fieldValue.toLowerCase() !== 'qml') return;
  if (!kobeCartType || kobeCartType !== 'vaccines') return;

  function buildSignatureStep(): HTMLElement {
    const li = document.createElement('li');
    li.className = 'checkout-step optimizedCheckout-checkoutStep checkout-step--vaccine';
    li.setAttribute('data-injected-signature-step', 'true');
    li.innerHTML = `
      <div class="checkout-view-header">
        <div class="stepHeader is-readonly">
          <div class="stepHeader-figure stepHeader-column">
            <div class="icon stepHeader-counter optimizedCheckout-step">
              <svg height="24" viewBox="0 0 24 24" width="24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path></svg>
            </div>
            <h2 class="stepHeader-title optimizedCheckout-headingPrimary">Signature</h2>
          </div>
          <div class="stepHeader-body stepHeader-column optimizedCheckout-contentPrimary" data-test="step-info"></div>
        </div>
      </div>
      <div class="checkout-view-content" style="margin-top:10px;">
        <p>To comply with the Medicines and Poisons (Medicines) Regulation 2021 (Queensland), a clinician or doctor must sign this order electronically by including the required information listed below.</p>
        <fieldset class="form-fieldset" style="display:flex;gap:10px;">
          <div class="form-field" style="width:100%;">
            <label class="form-label optimizedCheckout-form-label" for="doctor-name">Doctor name (required)</label>
            <input class="form-input optimizedCheckout-form-input" id="doctor-name" type="text" required>
          </div>
          <div class="form-field" style="width:100%;">
            <label class="form-label optimizedCheckout-form-label" for="provider-number">Provider number</label>
            <input class="form-input optimizedCheckout-form-input" id="provider-number" type="text" required>
          </div>
        </fieldset>
      </div>
    `;
    return li;
  }

  const isSignatureValid = (): boolean => {
    const doctorInput = document.querySelector<HTMLInputElement>('#doctor-name');
    const providerInput = document.querySelector<HTMLInputElement>('#provider-number');
    return !!(
      doctorInput &&
      providerInput &&
      doctorInput.value.trim() &&
      providerInput.value.trim()
    );
  };

  const signatureValues = (): string => {
    const doctorInput = document.querySelector<HTMLInputElement>('#doctor-name');
    const providerInput = document.querySelector<HTMLInputElement>('#provider-number');
    if (doctorInput && providerInput && doctorInput.value.trim() && providerInput.value.trim()) {
      return JSON.stringify({
        doctor_number: doctorInput.value.trim(),
        provider_number: providerInput.value.trim(),
      });
    }
    return '';
  };

  // UPDATED: stronger validation binding
  function bindValidation(): void {
    const doctorInput = document.querySelector<HTMLInputElement>('#doctor-name');
    const providerInput = document.querySelector<HTMLInputElement>('#provider-number');
    if (!doctorInput || !providerInput) return;

    const applyState = () => {
      // Re-select button each time (React may swap it)
      const btn = document.querySelector<HTMLButtonElement>('#checkout-payment-continue');
      if (!btn) return;
      const ok = isSignatureValid();
      if (ok) {
        const SIGNATURE_KEY = 'doctor_signature_payload';
        const lastPayload = sessionStorage.getItem(SIGNATURE_KEY) || '';
        const currentPayload = signatureValues();
        if (currentPayload !== lastPayload) {
          sendCustomCartData('doctor_signature', currentPayload);
          sessionStorage.setItem(SIGNATURE_KEY, currentPayload);
        }
        btn.disabled = false;
        btn.removeAttribute('disabled'); // kill attribute too
        btn.setAttribute('aria-disabled', 'false');
      } else {
        btn.disabled = true;
        btn.setAttribute('disabled', ''); // keep disabled firmly
        btn.setAttribute('aria-disabled', 'true');
      }
    };

    // input listeners (bind once)
    if (!doctorInput.dataset.validationBound) {
      const revalidate = () => applyState();
      doctorInput.addEventListener('input', revalidate);
      providerInput.addEventListener('input', revalidate);
      doctorInput.dataset.validationBound = 'true';
      providerInput.dataset.validationBound = 'true';
    }

    // backstop: block click/submit if not valid
    const btn = document.querySelector<HTMLButtonElement>('#checkout-payment-continue');
    if (btn && !btn.dataset.signatureGuardBound) {
      btn.addEventListener(
        'click',
        (e) => {
          if (!isSignatureValid()) {
            e.preventDefault();
            e.stopPropagation();
            applyState();
          }
        },
        true,
      ); // capture to beat other handlers
      btn.dataset.signatureGuardBound = 'true';
    }

    // initial state
    applyState();
  }

  function ensureInserted(): void {
    const paymentStep = document.querySelector<HTMLElement>(
      'li.checkout-step.optimizedCheckout-checkoutStep.checkout-step--payment',
    );
    if (!paymentStep) return;

    let existing = document.querySelector<HTMLElement>(
      'li.checkout-step--vaccine[data-injected-signature-step]',
    );
    if (!existing) {
      existing = buildSignatureStep();
      paymentStep.parentNode?.insertBefore(existing, paymentStep);
    } else if (existing.nextElementSibling !== paymentStep) {
      paymentStep.parentNode?.insertBefore(existing, paymentStep);
    }

    bindValidation();
  }

  ensureInserted();

  // Also re-validate on DOM churn (button swaps, etc.)
  const observer = new MutationObserver(() => {
    ensureInserted();
    // If only the button was replaced, ensure validation reapplies
    const btn = document.querySelector('#checkout-payment-continue');
    if (btn) (btn as HTMLButtonElement).disabled = !isSignatureValid();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// function observeCheckoutForOrderComments() {
//   const checkoutContainer = document.body;

//   const observer = new MutationObserver(() => {
//     const paymentStep = document.querySelector('li.checkout-step--payment .stepHeader.is-readonly');
//     const checkoutPaymentContinue = document.querySelector('#checkout-payment-continue');

//     if (paymentStep && checkoutPaymentContinue) {
//       fetchAndInjectCustomerMessage();
//     }
//   });

//   observer.observe(checkoutContainer, {
//     childList: true,
//     subtree: true,
//   });
// }

function replaceEmail() {
  const NEW_EMAIL = 'practice@medway.com.au';

  const observer = new MutationObserver(() => {
    const a = document.querySelector('a[href^="mailto:stephane.recouvreur@healius.com.au"]');
    if (!a) return;

    // Preserve query string (e.g. ?Subject=Order 119)
    const href = a.getAttribute('href');
    if (href) {
      const query = href.split('?')[1] || '';
      a.setAttribute('href', `mailto:${NEW_EMAIL}${query ? `?${query}` : ''}`);
    }

    // Update visible text
    if (a.textContent && a.textContent.trim() === 'stephane.recouvreur@healius.com.au') {
      a.textContent = NEW_EMAIL;
    }

    observer.disconnect(); // stop once updated
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
function replaceContinueShopping() {
  const observer = new MutationObserver(() => {
    const btn = document.querySelector('.continueButtonContainer form button');
    if (!btn) return;

    if (btn.textContent) {
      btn.textContent = 'Back to Medway Practice';
    }

    observer.disconnect(); // stop once updated
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function replaceConfirmationStatusText() {
  const observer = new MutationObserver(() => {
    const spanElement = document.querySelector(
      'p[data-test="order-confirmation-order-status-text"] span',
    );
    if (!spanElement) return;

    if (spanElement.textContent) {
      spanElement.textContent = 'Your order has been received. Thank you for your business.';
    }

    observer.disconnect(); // stop once updated
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function hideShippingFieldset() {
  const observer = new MutationObserver(() => {
    const fs = document.getElementById('checkout-shipping-options');
    if (fs) {
      fs.style.display = 'none';
      // leave observer running if the element gets re-added
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function watchForAddresses() {
  function readAddresses() {
    const raw = sessionStorage.getItem('kobe-company-addresses');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (err) {
      console.error('Invalid JSON in sessionStorage:', err);
      return null;
    }
  }

  // helper: get index of an LI within its list
  function indexOfLi(container: HTMLElement, li: Element): number {
    const items = Array.from(container.querySelectorAll('li.dropdown-menu-item'));
    return items.indexOf(li as HTMLElement);
  }

  // Run immediately in case elements already exist
  const observer = new MutationObserver(() => {
    if (
      document.getElementById('shippingAddresses') ||
      document.getElementById('billingAddresses')
    ) {
      const shipping = document.getElementById('shippingAddresses');
      const billing = document.getElementById('billingAddresses');
      const addresses = readAddresses();
      const shippingAddresses = addresses
        ? addresses
            .filter((a: AddressItemType) => a.isActive === 1 && a.isShipping === 1)
            .sort((a: AddressItemType, b: AddressItemType) => Number(a.id) - Number(b.id))
        : [];
      const billingAddresses = addresses
        ? addresses
            .filter((a: AddressItemType) => a.isActive === 1 && a.isBilling === 1)
            .sort((a: AddressItemType, b: AddressItemType) => Number(a.id) - Number(b.id))
        : [];
      if (shipping && shippingAddresses.length > 0) {
        const addressDropdownItems = shipping.querySelectorAll('li.dropdown-menu-item');
        addressDropdownItems.forEach((li, i) => {
          const fnEntry = li.querySelector('.fn.address-entry');
          if (fnEntry && shippingAddresses[i]) {
            // check if a label already exists
            if (!li.querySelector('.address-label')) {
              const newP = document.createElement('p');
              newP.className = 'address-entry address-label';
              newP.style.fontWeight = '700';
              newP.textContent = shippingAddresses[i].label; // or shippingAddresses[i].property
              fnEntry.before(newP);
            }
          }
        });

        // --- Selected shipping block (default shipping only) ---
        const selectedShippingAddress = sessionStorage.getItem(`kobe-shipping-selected-address`);
        let defaultShipping = null;
        if (selectedShippingAddress) {
          defaultShipping = JSON.parse(selectedShippingAddress);
        } else {
          defaultShipping = shippingAddresses.find(
            (a: AddressItemType) => a.isDefaultShipping === 1,
          );
        }
        if (defaultShipping?.label) {
          const selected = shipping.querySelector('.dropdownTrigger .fn.address-entry');
          if (selected && !selected.parentElement?.querySelector('.address-label')) {
            const newP = document.createElement('p');
            newP.className = 'address-entry address-label';
            newP.style.fontWeight = '700';
            newP.style.display = 'block';
            newP.textContent = defaultShipping.label;
            selected.before(newP);
          }
        }

        // CLICK: update selected label when a list item is chosen
        shipping.addEventListener(
          'click',
          (ev) => {
            const li = (ev.target as HTMLElement).closest('li.dropdown-menu-item');
            if (!li) return;
            const idx = indexOfLi(shipping, li);
            const addr = shippingAddresses[idx];
            sessionStorage.setItem(`kobe-shipping-selected-address`, JSON.stringify(addr));
          },
          { once: false },
        );
      } else if (billing && billingAddresses.length > 0) {
        const addressDropdownItems = billing.querySelectorAll('li.dropdown-menu-item');
        addressDropdownItems.forEach((li, i) => {
          const fnEntry = li.querySelector('.fn.address-entry');
          if (fnEntry && shippingAddresses[i]) {
            // check if a label already exists
            if (!li.querySelector('.address-label')) {
              const newP = document.createElement('p');
              newP.className = 'address-entry address-label';
              newP.style.fontWeight = '700';
              newP.textContent = shippingAddresses[i].label; // or shippingAddresses[i].property
              fnEntry.before(newP);
            }
          }
        });

        // --- Selected shipping block (default shipping only) ---
        const selectedShippingAddress = sessionStorage.getItem(`kobe-billing-selected-address`);
        let defaultBilling = null;
        if (selectedShippingAddress) {
          defaultBilling = JSON.parse(selectedShippingAddress);
        } else {
          defaultBilling = shippingAddresses.find((a: AddressItemType) => a.isDefaultBilling === 1);
        }
        if (defaultBilling?.label) {
          const selected = billing.querySelector('.dropdownTrigger .fn.address-entry');
          if (selected && !selected.parentElement?.querySelector('.address-label')) {
            const newP = document.createElement('p');
            newP.className = 'address-entry address-label';
            newP.style.fontWeight = '700';
            newP.style.display = 'block';
            newP.textContent = defaultBilling.label;
            selected.before(newP);
          }
        }

        billing.addEventListener(
          'click',
          (ev) => {
            const li = (ev.target as HTMLElement).closest('li.dropdown-menu-item');
            if (!li) return;
            const idx = indexOfLi(billing, li);
            const addr = billingAddresses[idx];
            sessionStorage.setItem(`kobe-billing-selected-address`, JSON.stringify(addr));
          },
          { once: false },
        );
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Checkout specific JS
if (window.location.href.includes('/checkout')) {
  const orderCommentObserver = new MutationObserver(() => {
    const input = document.querySelector<HTMLInputElement>('input[name="orderComment"]');
    if (input && !input.dataset.noteAdded) {
      const note = document.createElement('div');
      note.textContent = 'Add any special instructions for the warehouse team.';
      note.style.marginTop = '0.75rem';
      input.parentNode?.insertBefore(note, input.nextSibling);
      input.dataset.noteAdded = 'true';
      if (orderCommentObserver) {
        orderCommentObserver.disconnect();
      }
    }
  });
  orderCommentObserver.observe(document.body, { childList: true, subtree: true });

  const accCompanyObserver = new MutationObserver(() => {
    const b2bCompanyData = sessionStorage.getItem(`b2b-kobe-company-data`);
    if (b2bCompanyData) {
      const b2bCompany: CompanyState = JSON.parse(b2bCompanyData);

      if (b2bCompany.companyInfo.extraFields) {
        const businessType = b2bCompany.companyInfo.extraFields.find(
          (extraField) => extraField.fieldName.toLowerCase() === 'business type',
        );
        if (businessType && businessType.fieldValue.toLowerCase() === 'collection centre') {
          const cart = document.querySelector('[data-test=cart]') as HTMLElement | null;
          if (cart) {
            cart.style.minHeight = 'auto';
          }

          const selectorsToHide = [
            '[data-test=cart-subtotal]',
            '[data-test=cart-shipping]',
            '[data-test=cart-taxes]',
            '[data-test=tax-text]',
            '[data-test=cart-total]',
          ];

          selectorsToHide.forEach((selector) => {
            const el = document.querySelector(selector) as HTMLElement | null;
            if (el) el.style.display = 'none';
          });

          const productList = document.querySelector('.productList') as HTMLElement | null;
          if (productList) productList.style.borderBottom = 'none';

          const paymentUl = document.querySelector(
            '[data-test="payment-form"] .form-fieldset',
          ) as HTMLElement | null;
          if (paymentUl) paymentUl.style.display = 'none';

          const paymentHeader = document.querySelector(
            '.checkout-step--payment .checkout-view-header',
          ) as HTMLElement | null;
          if (paymentHeader) paymentHeader.style.display = 'none';

          const cartItems = document.querySelectorAll('[data-test=cart-item]');
          cartItems.forEach((item) => {
            const productBody = item.querySelector('.product-body') as HTMLElement | null;
            if (productBody) productBody.style.width = '100%';

            const productPrice = item.querySelector(
              '[data-test=cart-item-product-price]',
            ) as HTMLElement | null;
            if (productPrice) productPrice.style.display = 'none';
          });

          // Click checkout continue button if exists (React-safe)
          const continueBtn = document.getElementById(
            'checkout-shipping-continue',
          ) as HTMLButtonElement | null;
          if (continueBtn) continueBtn.click();
        }
      }
    }
  });
  accCompanyObserver.observe(document.body, { childList: true, subtree: true });

  const paymentContinueObserver = new MutationObserver(() => {
    const btn = document.querySelector('#checkout-payment-continue');
    if (btn && btn.textContent && btn.textContent.trim() === 'Place Order') {
      btn.textContent = 'Place order'; // lowercase "o"
    }
  });

  paymentContinueObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  hideShippingFieldset();

  // Start observing
  // observeCheckoutForOrderComments();

  // Run this after the DOM is ready (or after your main observer)
  observeAndHideShippingComments();
  observerQueenslandSignature();
  // observeAndRemoveCartEditLink();
  hidePaymentInstruction();
  watchForAddresses();
  initCartLinkOverride();
}

if (window.location.pathname.includes('checkout/order-confirmation')) {
  localStorage.removeItem('healius-last-cart-vaccines');
  localStorage.removeItem('healius-last-cart-consumables');
  replaceEmail();
  replaceContinueShopping();
  addCommaAfterThankYou();
  replaceConfirmationStatusText();
}
